import { Snack } from '@nike/eds'
import { useGetShipmentMaterialsLazyQuery } from '../../generated/graphql'
import { ApolloResult } from '../../common/ApolloResult'
import { useEffect } from 'react'
import { shipmentMaterialsTableColumns } from './ShipmentMaterialsTableColumns'
import { SimpleTable } from '../../common/components/table/SimpleTable'

export function ShipmentMaterialsTable({ packlistNumber }) {
  const [fetchShipmentMaterials, shipmentMaterialsQueryResult] = useGetShipmentMaterialsLazyQuery({
    variables: {
      packlistNumber,
    },
    context: {
      page: 'goodsholderitems',
    },
  })
  const shipmentMaterials = shipmentMaterialsQueryResult?.data?.getShipmentMaterials

  //Use effect to force refresh when the page is revisited
  useEffect(() => {
    fetchShipmentMaterials()
  }, [fetchShipmentMaterials, packlistNumber])

  return (
    <div>
      <ApolloResult {...shipmentMaterialsQueryResult}>
        {shipmentMaterials?.length > 0 ? (
          <SimpleTable
            columns={shipmentMaterialsTableColumns}
            data={shipmentMaterials}
            className="goods-holder-items-table"
          />
        ) : (
          <Snack id="no-materials-snack" hideDismiss={true} status="info">
            No materials found
          </Snack>
        )}
      </ApolloResult>
    </div>
  )
}
